<template>
  <v-container
    class="fill-height d-flex flex-column align-center justify-center text-center"
  >
    <v-icon size="96" color="error">mdi-alert-circle</v-icon>
    <h1 class="text-h4 font-weight-bold mt-4">404 - Página no encontrada</h1>
    <p class="text-subtitle-1 mb-6">La pagina que buscas no existe 😢</p>
    <v-btn color="primary" variant="flat" @click="$router.push('/')">
      Regresar al Login
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: "NotFound",
};
</script>
